<template>
	<div>
		<h2 style="margin:30px 0">{{cmp.name}}</h2>
		<qrcode-vue id="qr" :value="rqval" size="400" ref="erweima"></qrcode-vue>
		<h4 style="margin:30px 0">注:该二维码为用户进入小程序入口，可自行下载，打印张贴在工地或发送给用户</h4>
		<a :href="url" download="二维码" style="width:300px;height:40px;line-height:40px;margin-bottom:200px;" class="ant-btn ant-btn-primary" >下载二维码</a>
	</div>
</template>


<script>
import QrcodeVue from "./qrcode.vue.min.js"
import {getone} from '@/api/company.js'
export default {
	data(){
		let userinfo = sessionStorage.getItem("userinfo")
		userinfo = JSON.parse(userinfo)
		return {
			rqval:`https://jzqiyi.com/signcontract/user?company=${userinfo.cmpid}`,
			userinfo,
			url:'',
			cmp:{name:"",id:""}
		}
	},
	methods:{
		getcompanyinfo(){
			let {cmpid} = this.userinfo
			let outc = getone({id:cmpid}).then(ret=>{
				if(ret.code == 0){
					let {cmp} = ret
					this.cmp = cmp
				}
			})
		},
	},
	components:{
		QrcodeVue	
	},
	mounted(){
		// this.getcompanyinfo()
		let canvas = document.getElementById("qr").children[0]
		this.url = canvas.toDataURL("image/png")
	}
}
</script>

